import React from 'react';
import Topbar from './Topbar'; // Assuming Topbar is in components
import '../css/InformationPage.css'; // We'll create this CSS file
import { Button } from 'react-bootstrap';
import confused from '../assets/images/confused.png';

interface InformationPageProps {
  imageSrc?: string;
  title: string;
  subtitle: string;
  buttonLabel?: string;
  buttonLink?: string;
}

const InformationPage: React.FC<InformationPageProps> = ({
  imageSrc,
  title,
  subtitle,
  buttonLabel,
  buttonLink,
}) => {
  const handleButtonClick = () => {
    window.location.href = buttonLink!;
  };
  if (!imageSrc) {
    imageSrc = confused; // Default image if none provided
  }
  return (
    <div className="information-page-container">
      <Topbar />
      <div className="information-page-content">
        <img src={imageSrc} alt={title} className="information-image" />
        <h1 className="information-title">{title}</h1>
        <p className="information-subtitle">{subtitle}</p>
        { buttonLabel && <Button variant='outline-primary' onClick={handleButtonClick}>
          {buttonLabel}
        </Button>}
      </div>
    </div>
  );
};

export default InformationPage;
